//@ts-check
import React from 'react';
//@ts-ignore
import config from '@plone/volto/registry';
//@ts-ignore
import { RenderBlocks } from '@plone/volto/components';
import { CustomContainer } from '../general';

export const TwoColumnsView = (props) => {
  const { data, path } = props;
  const metadata = props.metadata || props.properties;
  const blocksConfig =
    config.blocks.blocksConfig[data['@type']].blocksConfig ||
    props.blocksConfig;
  const location = {
    pathname: path,
  };
  return (
    <CustomContainer
      className="grid grid-cols-1 sm:grid-cols-2 gap-16"
      size={'ensino-institucional'}
      alignCenter={true}
    >
      <RenderBlocks
        {...props}
        metadata={metadata}
        content={data}
        location={location}
        blocksConfig={blocksConfig}
        isContainer
      />
    </CustomContainer>
  );
};
